import React, { useState, useEffect } from "react";
import "./Navbar.css";
import resume from "./assets/ShivanshShrivas_Resume.pdf";

function Navbar() {
  const [isMobile, setIsMobile] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobile(!isMobile);
  };

  function handleClick(ClassName) {
    const section = document.querySelector(ClassName);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  }

  return (
    <nav className={`navbar ${isScrolled ? "scrolled" : ""}`}>
      <div className="navbar-container">
        <div className="navbar-logo">
          <p>Shivansh Shrivas</p>
        </div>
        <ul className={`nav-links ${isMobile ? "mobile" : ""}`}>
          <li>
            <p
              onClick={() => {
                handleClick(".projects-section");
              }}
            >
              Projects
            </p>
          </li>
          <li>
            <p
              onClick={() => {
                handleClick(".skills-section");
              }}
            >
              Skills
            </p>
          </li>
          <li>
            <p
              onClick={() => {
                handleClick(".contact-section");
              }}
            >
              Contact
            </p>
          </li>
          <li>
            <button
              className="resume-btn"
              onClick={() => window.open(resume, "_blank")}
            >
              Resume
            </button>
          </li>
        </ul>
        <div className="menu-toggle" onClick={toggleMobileMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
